import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-monitoring-comments-config',
  templateUrl: 'monitoring-comments-config.component.html'
})
export class MonitoringCommentsConfigComponent {

  @Input()  item: any;
  @Input()  customData: any;
  @Output() sendEvent = new EventEmitter<any>();

  constructor(
  ) {
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

  setAlign(element: any, align: string): void {
    element = align;
  }

}
